<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
  />
</template>

<script setup lang="ts">
  import { computed, defineComponent } from 'vue'
  import * as HeroIcons from '@heroicons/vue/outline'
  import * as HeroIconsSolid from '@heroicons/vue/solid'

  const props = withDefaults(defineProps<{ icon: string; type?: string }>(), {
    type: 'outline',
  })
  const iconComponent = computed(() => {
    if (props.type === 'outline') {
      if (HeroIcons[props.icon]) {
        return HeroIcons[props.icon]
      }
    } else {
      if (HeroIconsSolid[props.icon]) {
        return HeroIconsSolid[props.icon]
      }
    }
    return null
  })
</script>
